@if (form) {
  <div [formGroup]="form" class="form">
    <div class="flex flex-column gap-2 mb-3">
      <label class="font-semibold w-full" for="role"
        >{{ "admin.tenant_administration.user_form.role" | translate }}*</label
      >
      <p-select
        name="role"
        formControlName="role"
        autoWidth="false"
        [options]="roles()"
        [style]="{ width: '100%' }"
        optionValue="label"
        [placeholder]="translate.instant('admin.tenant_administration.user_form.choose_role')"
        appendTo="body"
      >
        <ng-template let-role #item>
          <span>{{ (role.label ? role.label : "") | translate }}</span>
        </ng-template>
        <ng-template let-role #selectedItem>
          <span>{{ (role.label ? role.label : "") | translate }}</span>
        </ng-template>
      </p-select>
    </div>
    <!-- class="flex flex-column gap-2 mb-3" -->
    <div class="flex flex-column gap-2 mb-3">
      <label for="email" class="font-semibold w-full"
        >{{ "admin.tenant_administration.user_form.email" | translate }}*</label
      >
      <input pInputText id="email" formControlName="email" autocomplete="off" />
    </div>

    <div class="flex flex-column gap-2 mb-3">
      <label for="firstName" class="font-semibold w-full"
        >{{ "admin.tenant_administration.user_form.first_name" | translate }}*</label
      >
      <input pInputText id="firstName" formControlName="firstName" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="lastName" class="font-semibold w-full"
        >{{ "admin.tenant_administration.user_form.last_name" | translate }}*</label
      >
      <input pInputText id="lastName" formControlName="lastName" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label class="font-semibold w-full" for="faultListPermission"
        >{{ "wiki.access_levels.form_title" | translate }}*</label
      >
      <p-select
        name="faultListPermission"
        formControlName="faultListPermission"
        autoWidth="false"
        [options]="wikiLevelOptions"
        [style]="{ width: '100%' }"
        [placeholder]="translate.instant('wiki.access_levels.form_placeholder')"
        appendTo="body"
      >
        <ng-template let-wikiLevelOption #item>
          <span>{{ (wikiLevelOption.label ? wikiLevelOption.label : "") | translate }}</span>
        </ng-template>
        <ng-template let-wikiLevelOption #selectedItem>
          <span>{{ (wikiLevelOption.label ? wikiLevelOption.label : "") | translate }}</span>
        </ng-template>
      </p-select>
    </div>

    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
    </div>
  </div>
}
